import { createFileRoute } from "@tanstack/react-router";
import LeafBlowerGuide from "@/pages/LeafBlowerGuide";

export const Route = createFileRoute("/guides/best-leaf-blowers-uk")({
  component: LeafBlowerGuide,
  head: () => {
    const title = "Best Leaf Blowers UK 2024: Complete Buying Guide & Reviews";
    const description = "Find the perfect leaf blower for your UK garden. Compare cordless, electric & petrol models with our comprehensive buying guide and top 10 recommendations.";
    const url = "https://www.garden-review.co.uk/guides/best-leaf-blowers-uk";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "keywords", content: "leaf blower, garden tools, autumn cleanup, cordless blower, electric blower, petrol blower, UK gardens" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
});
